import { g as get$1 } from './b6480678.mjs';

const COOKIE_PREFIX = "toggle_";
function get(toggleName, defaultValue = false) {
  var _a, _b, _c, _d;
  const localStatus = get$1(COOKIE_PREFIX + toggleName);
  if (((_b = (_a = window.o_global) == null ? void 0 : _a.toggles) == null ? void 0 : _b[toggleName]) === true || localStatus === "true") {
    return true;
  }
  if (((_d = (_c = window.o_global) == null ? void 0 : _c.toggles) == null ? void 0 : _d[toggleName]) === false || localStatus === "false") {
    return false;
  }
  return typeof defaultValue === "boolean" ? defaultValue : false;
}

var index = /*         */Object.freeze({
  __proto__: null,
  get: get
});

export { get as g, index as i };
/*                                 */
